import { Component, OnInit, ViewChild } from "@angular/core";
import { BiometricService } from 'src/app/services/biometric/biometric.service';
import { Platform } from '@ionic/angular';
import { EventsService } from 'src/app/services/event/event.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { BoydRewardsService } from 'src/app/services/boyd-rewards/boyd-rewards.service';
@Component({ 
  selector: 'app-biometric-switch',
  templateUrl: './biometric-switch.component.html',
  styleUrls: ['./biometric-switch.component.scss'],
})

export class BiometricSwitchComponent implements OnInit {
  public waitingForConfirm: boolean = false;
  public biometricStatus: boolean = true;
  public isBoydCardConnected: boolean = false;
  constructor(
    public platform: Platform,
    private eventsService: EventsService,
    private navigator: Navigator,
    private boydRewardsService: BoydRewardsService,
    private biometricService: BiometricService,
  ) { }

  ngOnInit(): void {
    this.biometricStatus = !this.biometricService.useBiometric;
    
    this.eventsService.subscribe('event:biometric:toggleresult', (data) => {
      if(this.waitingForConfirm){
        this.biometricStatus = data.toggleresult?!this.biometricStatus:this.biometricStatus;
        this.waitingForConfirm = false;
      }
    });

    this.boydRewardsService.checkConnectionToBoydCard().subscribe((res) => {
      if (!res) {
        this.isBoydCardConnected = false;
      } else {
        this.isBoydCardConnected = true;
      }
    }).unsubscribe();
  }

  protected onToggleBiometric(): any {
    if (this.platform.is('capacitor')){
      this.waitingForConfirm = true;
      this.navigator.openPopover('PopoverBiometricComponent', {biometricStatus:this.biometricService.useBiometric,isBoydCardConnected:this.isBoydCardConnected}, 'settings-popover', true, true, true, -1, 'cover', false);
    }
  }

}